import React from "react";
import {observer} from "mobx-react-lite";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import {File} from "../../shared/Types";
import styles from "./MarkdownViewer.module.scss";

type Props = {
	file: File;
	fontSize: number;
	height: string;
};

const MarkdownViewer: React.FC<Props> = (props: Props) => {
	return (
		<div
			id={"markdownWrapper"}
			className={styles.markdownWrapper}
			style={{fontSize: props.fontSize + "rem", height: props.height}}
		>
			<Markdown rehypePlugins={[rehypeRaw] as any}>{props.file.value}</Markdown>
		</div>
	);
};

export default observer(MarkdownViewer);
